import { render, staticRenderFns } from "./HugeInputBox.vue?vue&type=template&id=2a49b9d6&scoped=true&"
import script from "./HugeInputBox.vue?vue&type=script&lang=js&"
export * from "./HugeInputBox.vue?vue&type=script&lang=js&"
import style0 from "./HugeInputBox.vue?vue&type=style&index=0&id=2a49b9d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49b9d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
